<template>
  <section>
    <div v-if="loading" class="content content-centered">
      <pulse-loader></pulse-loader>
    </div>
    <div v-show="!loading" class="content">
      <div class="box">
        <div class="box-body">
          <div class="row">
            <div class="flash-message col-md-4 col-md-offset-4 text-center" v-if="flash">
              <div class="alert" :class="'alert-' + flashType">
                {{ flashMessage }}
              </div>
            </div>
          </div>
          <div id="details">
            <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
              <!-- v-permission.if="[USER_ROLES.ADMIN]" !! v-if="this.user.roleName == 'Admin'" -->
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.region)">
                    <label>Geographical Area</label>
                    <vue-select label="value" :options="this.region_list" :searchable="true" language="en-US"
                      v-model="trip.region" @input="selectGA">
                    </vue-select>

                  </validate>
                  <field-messages name="region" show="$touched || $submitted" class="form-control-feedback">
                    <div slot="required">
                      Geographical Area is a required field
                    </div>
                  </field-messages>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-4">
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.vehicleId)">
                    <label>Vehicle</label>
                    <vue-select label="value" :options="this.vehicle_no" :searchable="true" language="en-US"
                      v-model="trip.vehicleId" @input="getDeviceName">
                    </vue-select>
                    <field-messages name="vehicleId" show="$touched || $submitted" class="form-control-feedback">
                      <div slot="required">Vehicle is a required field</div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-4">
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.deviceId)">
                    <label>Device</label>
                    <input v-model="trip.deviceId" disabled type="text" name="message" placeholder="Device"
                      class="form-control" id="chat-input" />
                    <field-messages name="deviceId" show="$touched || $submitted" class="form-control-feedback">
                      <div slot="required">Device is a required field</div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-4">
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.driverId)">
                    <label for="journeyManager" class="control-label">
                      Drivers
                    </label>
                    <vue-select label="drivers" multiple :options="this.driver_name" @input="driverStatus"
                      :searchable="true" language="en-US" v-model="trip.driverId">
                    </vue-select>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-3">
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.regionManager)">
                    <label>HCV Operation Manager</label>
                    <!-- <select v-model="trip.regionManager" :disabled="isGAHeadDisable" required name="regionManager"
                      class="form-control">
                      <option selected disabled>Select HCV Operation Manager</option>
                      <option v-for="(item, index) in region_managers" :key="index" :value="item.key">
                        {{ item.value }}
                      </option>
                    </select> -->

                    <vue-select label="value" :options="this.region_managers" @input="HCVOperationStatus"
                      :searchable="true" language="en-US" v-model="trip.regionManager">
                    </vue-select>
                    <field-messages name="regionManager" show="$touched || $submitted" class="form-control-feedback">
                      <div slot="required">
                        HCV Operation Manager is a required field
                      </div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-3">
                  <validate auto-label class="form-group required-field"
                    :class="fieldClassName(formstate.journeyManager)">
                    <label>Journey Manager</label>
                    <!-- <select v-model="trip.journeyManager" :disabled="isJourenyManagerDisable" required
                      name="journeyManager" class="form-control">
                      <option value="" disabled>Select Jouney Manager</option>
                      <option v-for="(item, index) in journey_managers" :key="index" :value="item.key">
                        {{ item.value }}
                      </option>
                    </select> -->
                    <vue-select label="value" :options="this.journey_managers" @input="journeyManagerStatus"
                      :searchable="true" language="en-US" v-model="trip.journeyManager">
                    </vue-select>
                    <field-messages name="journeyManager" show="$touched || $submitted" class="form-control-feedback">
                      <div slot="required">
                        Journey Manager is a required field
                      </div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-3">
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.scheduleDate)">
                    <label>Scheduled Date</label>
                    <date-picker id="scheduleDate" disabled required v-model="trip.scheduleDate" lang="en"
                      name="scheduleDate" :not-before="disabledBefore" input-class="form-control" width="100%"
                      use-utc="true" format="DD-MM-YYYY"></date-picker>
                    <field-messages name="scheduleDate" show="$touched || $submitted" class="form-control-feedback">
                      <div slot="required">
                        Schedule Date is a required field
                      </div>
                      <div slot="pattern">Schedule Date is invalid</div>
                    </field-messages>
                  </validate>
                </div>
                <div class="col-sm-3">
                  <label>Scheduled Time</label>
                  <validate auto-label class="form-group required-field" :class="fieldClassName(formstate.scheduledTime)">
                    <vue-timepicker name="scheduledTime" disabled required v-model="scheduledTime"
                      style="width: 271px"></vue-timepicker>
                    <field-messages name="scheduledTime" show="$touched || $submitted" class="form-control-feedback">
                      <div slot="required">
                        Schedule Time is a required field
                      </div>
                    </field-messages>
                  </validate>
                </div>
              </div>
              <div class="col-sm-12">
                <div class="col-sm-6">
                  <validate auto-label class="form-group" :class="fieldClassName(formstate.remark)">
                    <label>Remarks</label>
                    <textarea name="remark" class="form-control" v-model="trip.remark" placeholder="Remarks"></textarea>
                  </validate>
                </div>
              </div>

              <div class="col-sm-12">
                <div class="col-sm-4">

                  <div v-for="(input, index) in locations" :key="index" class="">
                    <validate auto-label class="form-group required-field">
                      <label v-if="index === 0">Start Location</label>
                      <label v-else-if="index === locations.length - 1">End Location</label>
                      <label v-else>Halt {{ index }}</label>

                      <!-- <select v-model="input.locationId" required class="form-control"
                        @change="handleChange($event, index)">
                        <option selected disabled>Select Location</option>
                        <option v-for="(item, itemIndex) in getFilteredLocationList(
                          index,
                        )" :key="itemIndex" :value="item">
                          {{ item.siteName }}
                        </option>
                      </select> -->

                      <vue-select label="siteName" @change="handleChange($event, index)" :options="getFilteredLocationList(
                        index,
                      )" :searchable="true" language="en-US" v-model="input.locationId">
                      </vue-select>
                      <field-messages name="regionManager" show="$touched || $submitted" class="form-control-feedback">
                        <div slot="required">
                          HCV Operation Manager is a required field
                        </div>
                      </field-messages>
                    </validate>
                    <svg v-if="index === locations.length - 2" @click="addField('locations')"
                      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                      class="ml-2 cursor-pointer svg-icons">
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path fill="green"
                        d="M11 11V7h2v4h4v2h-4v4h-2v-4H7v-2h4zm1 11C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z" />
                    </svg>
                    <svg v-if="index > 1 && index < locations.length - 1" @click="removeField(index, 'locations')"
                      xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24"
                      class="ml-2 cursor-pointer svg-icons">
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path fill="#EC4899"
                        d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-9.414l2.828-2.829 1.415 1.415L13.414 12l2.829 2.828-1.415 1.415L12 13.414l-2.828 2.829-1.415-1.415L10.586 12 7.757 9.172l1.415-1.415L12 10.586z" />
                    </svg>
                  </div>
                </div>
              </div>
            </vue-form>
            <div class="col-sm-12 text-right">
              <router-link :to="{ name: 'TripGroup' }">
                <button class="mr-5 btn btn-default" type="button">
                  Cancel
                </button>
              </router-link>
              <button class="mr-2 btn gradientbt" type="submit" @click="createTrip"
                :disabled="!(formstate.$valid && formValid)">
                Add Group Trip
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal name="gasFlowDia" height="425" :adaptive="false" :click-to-close="false">
      <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">
          <!-- <b>{{editGasFlow.title}}</b> -->
          <button type="button" class="close" aria-label="Close" @click="$modal.hide('gasFlowDia')">
            <span aria-hidden="true">&times;</span>
          </button>
        </h4>
      </div>

      <div class="modal-body">
        <table class="table table-bordered">
          <tr style="marginTop:10px">
            <th>Start Location:</th>
            <td>
              <input class="form-control" required v-model="routeData.startLocation" placeholder="Start Location"
                disabled />
              <!-- <datetime type="datetime" v-model="routeData.startLocation" use12-hour></datetime> -->
            </td>
          </tr>
          <tr style="marginTop:10px">
            <th>End Location:</th>
            <td>
              <input class="form-control" required v-model="routeData.endLocation" placeholder="End Location" disabled />
              <!-- <datetime type="datetime" v-model="trip.startDate" use12-hour></datetime> -->
            </td>
          </tr>
          <tr style="marginTop:10px">
            <th>Approx. Time (in Min) :</th>
            <td>
              <input type="number" class="form-control" required v-model="routeData.time" placeholder="Approx. Time" />
            </td>
          </tr>
          <tr style="marginTop:10px">
            <th>Approx. Distance(km) :</th>
            <td>
              <input type="number" class="form-control" required v-model="routeData.distance"
                placeholder="Approx. Distance" />
            </td>
          </tr>

          <!-- <tr style="marginTop:10px">
            <th>Region :</th>
            <td>
              <select
                v-model="routeData.region"
                required
                name="region"
                class="form-control"
              >
                <option value="" disabled>Select G.A</option>
                <option
                  v-for="(item, index) in region_list"
                  :key="index"
                  :value="item.key"
                >
                  {{ item.value }}
                </option>
              </select>
            </td>
          </tr> -->

          <!-- <tr v-if="trip.status == 'ongoing'">
                  <th>Change Trip Status</th>
                  <td>
                    <select class="form-control" @change="changeStatus" v-model="statusValue">
                      <option value="completed">Completed</option>
                      <option value="cancelled">Cancelled</option>
                    </select>
                  </td>
                </tr> -->
        </table>

        <div class="text-right" style="margin-top:20px">
          <button class="btn btn-primary" @click="closeRoute()">Close</button>
          <button class="btn btn-primary" @click="createRoute()">Save</button>
        </div>
      </div>
    </modal>
  </section>
</template>

<script>
import {
  formService,
  eventBus,
  tripService,
  tripRouteService,
} from '../../../services';
import { EVENTS } from '../../../config';
import Config, { USER_ROLES } from '../../../config';
import { mapState } from 'vuex';
import 'vue2-timepicker/dist/VueTimepicker.css';
import axios from 'axios';
import moment from 'moment';

export default {
  name: 'TripGroupCreate',
  data() {
    return {
      regionManagersIdList: [],
      // USER_ROLES: USER_ROLES,
      clearIndex: null,
      startLocation: null,
      intermediateLocations: [
        {
          locationId: '',
        },
      ],
      endLocation: null,
      tripLocationList: [],
      loading: false,
      disabledBefore: new Date(),
      isDeviceDisable: false,
      isJourenyManagerDisable: false,
      isGAHeadDisable: false,
      flash: false,
      flashType: null,
      flashMessage: '',
      EVENTS: EVENTS,
      formstate: {},
      region_list: {},
      region_managers: {},
      start_site: {},
      end_site: {},
      vehicle_no: {},
      route_list: {},
      driver_name: [],
      device_name: {},
      journey_managers: {},
      projectFormat: 'hh:mm',
      status: 'scheduled',
      sourceSite: '',
      destinationSite: '',
      device: {
        status: 'active',
      },
      trip: {
        vehicleId: '',
        deviceId: '',
        journeyManager: '',
        regionManager: '',
        driverId: '',
        subTrips: [],
        remark: '',
        region: '',
      },

      routeData: {
        startLocation: '',
        endLocation: '',
        time: '',
        distance: '',
        startLocId: '',
        endLocId: '',
        routeMarkers: [{
          latitude: '',
          longitude: '',
          message: '',
        },
        {
          latitude: '',
          longitude: '',
          message: '',
        }],
      },
      driver: [],
      locationList: [],
      locations: [
        {
          locationId: '',
        },
        {
          locationId: '',
        },
        {
          locationId: '',
        },
      ],
      list: [],
      params: {},
      selectedDeviceId: '',
      journeyManagerId: [],
      gAId: '',
      regionListFilter: [],
      regionManagerId: '',
      journeyManagerId: [],
      matchingRoutes: [],
      inputValid1: false,
      inputValid2: false,
      inputValid3: false,
      inputValid4: false,
      inputValid5: false,
      inputValid6: false,
      inputValid7: false,
      formValid: false,
      routeMarkers: [],
    };
  },
  created() {
    let regionDetails = this.$store.state.auth.userRegion.regionDetails;
    if (regionDetails && regionDetails.length !== 0) {
      this.regionManagersIdList = regionDetails.map(item => item.regionManager);
    }
  },
  mounted: function () {
    (this.trip.scheduleDate = new Date().toISOString().split('T')[0]),
      (this.scheduledTime = moment(new Date()).format('H:mm'));

    if (this.user.roleName == 'Admin') {
      this.getRegionList();
      this.getRouteName();
    }
    if (this.user.roleName !== 'Admin') {
      this.getRouteName();
      // if (this.user.roleName != 'Journey Manager') {
      //   this.getJourneyManager();
      // }
      this.getRegionList();
    }
  },

  methods: {
    getFilteredLocationList(index) {
      //0th index selected LNGT then all other must be LNGT
      //otherwise all must be according to condition
      var stations = [];
      if (
        this.locations[0] &&
        this.locations[0].locationId.siteType === 'LNGT'
      ) {
        if (index === 0) {
          stations = this.locationList.filter(
            el => el.siteType === 'MS' || el.siteType === 'LNGT',
          );
        } else {
          stations = this.locationList.filter(el => el.siteType === 'LNGT');
        }
      } else if (
        (index === 0 || index === this.locations.length - 1) &&
        this.locations[0].locationId.siteType !== 'LNGT'
      ) {
        stations = this.locationList.filter(
          el => el.siteType === 'MS' || el.siteType === 'LNGT',
        );
      } else {
        stations = this.locationList.filter(
          el =>
            el.siteType === 'DBS' ||
            el.siteType === 'DCU' ||
            el.siteType === 'DS',
        );
      }

      return stations;
    },

    updateFormValidity() {
      this.formValid =
        this.inputValid1 &&
        this.inputValid2 &&
        this.inputValid3 &&
        this.inputValid4 &&
        this.inputValid5 &&
        this.inputValid6;
    },
    updateFormFalse() {
      if (
        this.inputValid1 ||
        this.inputValid2 ||
        this.inputValid3 ||
        this.inputValid4 ||
        this.inputValid5 ||
        this.inputValid6
      ) {
        this.formValid = false;
      }
    },
    driverStatus() {
      if (this.trip.driverId.length > 0) {
        this.inputValid3 = true;
        this.updateFormValidity();
      } else {
        this.inputValid3 = false;
        this.updateFormFalse();
      }
    },
    HCVOperationStatus() {
      if (
        this.trip.regionManager !== null &&
        typeof this.trip.regionManager === 'object' &&
        this.trip.regionManager.key !== ''
      ) {
        this.inputValid4 = true;
        this.updateFormValidity();
      } else {
        this.inputValid4 = false;
        this.updateFormFalse();
      }
    },
    journeyManagerStatus() {
      if (
        this.trip.journeyManager !== null &&
        typeof this.trip.journeyManager === 'object' &&
        this.trip.journeyManager.key !== ''
      ) {
        this.inputValid5 = true;
        this.updateFormValidity();
      } else {
        this.inputValid5 = false;
        this.updateFormFalse();
      }
    },
    selectGA(e) {

      if (
        this.trip.region !== null &&
        typeof this.trip.region === 'object' &&
        this.trip.region.key !== ''
      ) {
        this.inputValid1 = true;
        this.updateFormValidity();
      } else {
        this.inputValid1 = false;
        this.updateFormFalse();
      }
      this.gAId = e.key;
      this.getDriverName();
      this.getVehicle();
      const filteredRegion = this.regionListFilter.find(
        item => item._id === this.gAId,
      );
      this.regionManagerId = filteredRegion
        ? filteredRegion.regionManager
        : null;
      this.journeyManagerId = filteredRegion
        ? filteredRegion.journeyManager
        : null;
      this.getRegionManager();
      this.getJourneyManager();
      this.getLocations();
    },

    fieldClassName: formService.fieldClassName,
    createTrip() {
      this.loading = true;

      for (let indexx = 1; indexx < this.locations.length; indexx++) {
        const el = this.route_list.find(
          el =>
            this.locations[indexx - 1].locationId._id === el.startSite &&
            this.locations[indexx].locationId._id === el.endSite,
        );

        if (el) {
          let val = {
            routeId: el._id,
            startSite: el.startSite,
            endSite: el.endSite,
          };
          this.matchingRoutes.push(val);
        }

      }
      // for (let i = 0; i < this.locations.length; i++) {
      //   let routeMarkers = {
      //     latitude: this.locations[i].locationId.latitude,
      //     longitude: this.locations[i].locationId.longitude,
      //     message: this.locations[i].locationId.siteName,
      //   }
      //   this.routeMarkers.push(routeMarkers);
      // }
      // console.log('routeMarkersrouteMarkers', this.routeMarkers)

      this.driver = this.trip.driverId.map(el => {
        return el.value;
      });
      console.log('createTrip1', this.trip);

      let trip = {
        driverId: this.driver,
        status: this.status,
        scheduleTime: this.scheduledTime,
        deviceId: this.selectedDeviceId,
        journeyManager: this.trip.journeyManager.key,
        regionManager: this.trip.regionManager.key,
        scheduleDate: this.trip.scheduleDate,
        vehicleId: this.trip.vehicleId.key,
        subTrips: this.matchingRoutes,
        remark: this.trip.remark,
        geographical_area: this.trip.region.key,
        // routeMarkers: this.routeMarkers,
      };
      console.log('createTrip', this.trip);
      return tripService
        .tripGroupAdd(trip)
        .then(response => {
          this.loading = false;
          this.flash = false;
          this.$snotify.success('TripGroup added!', 'Success!');
          this.$router.push('/trip-group');
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('TripGroup Add failed! Try Again', 'Error!');
          if (error.data.message == 'dvgdxfv') {
            this.$snotify.success('TripGroup added!', 'Success!');
            this.$router.push('/trip-group');
          }
        });
    },

    getRegionManager() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      if (this.gAId !== '') {
        params._id = this.regionManagerId;
      }
      let regionManagerList = [];
      if (this.user.roleName == 'Journey Manager') {
        this.$userRepository
          .list(params)
          .then(res => {
            this.loading = false;
            if (res.data.docs) {
              regionManagerList = res.data.docs.map(item => {
                return {
                  key: item._id,
                  value: item.firstName + ' ' + item.lastName,
                };
              });
            }
            this.region_managers = regionManagerList;
          })
          .catch(error => {
            this.loading = false;
            this.$snotify.error('Get region manager list failed', 'Error!');
          });
      } else {
        params.roleRank = 2;
        this.$userRepository
          .list(params)
          .then(res => {
            this.loading = false;

            if (res.data.docs) {
              regionManagerList = res.data.docs.map(item => {
                return {
                  key: item._id,
                  value: item.firstName + ' ' + item.lastName,
                };
              });
            }
            this.region_managers = regionManagerList;
          })
          .catch(error => {
            this.loading = false;
            this.$snotify.error('Get region manager list failed', 'Error!');
          });
      }
    },
    getJourneyManager() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      params.roleRank = 3;
      if (this.gAId !== '') {
        params._id = this.journeyManagerId;
      }
      let journeyManagerList = [];
      if (this.user.roleName == 'Journey Manager') {
        let bAsString = this.journeyManagerId.map(value => String(value));
        let jsonString = JSON.stringify(bAsString);
        params._id = jsonString;
        // params._id = `${this.user._id}`;
        // this.isJourenyManagerDisable = true;
        // this.trip.journeyManager = this.user._id;
      }
      this.$userRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            journeyManagerList = res.data.docs.map(item => {
              return {
                key: item._id,
                value: item.firstName + ' ' + item.lastName,
              };
            });
          }
          this.journey_managers = journeyManagerList;
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Get journey manager list failed', 'Error!');
        });
    },
    getSites(e) {
      this.sourceSite = e.target.options[e.target.selectedIndex].getAttribute(
        'sourceSite',
      );
      this.destinationSite = e.target.options[
        e.target.selectedIndex
      ].getAttribute('destinationSite');
    },
    getVehicle() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      if (this.gAId !== '') {
        params.region = this.gAId;
      }
      if (this.user.roleName == 'GA Head') {
        params.regionRegionManager = this.user._id;
      }

      if (this.user.roleName == 'Journey Manager') {
        params.regionJourneyManager = `["${this.user._id}"]`;
      }
      console.log('vehicle');
      let vehicleList = [];
      this.$vehicleDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            vehicleList = res.data.docs.map(item => {
              return {
                key: item._id,
                value: item.regNo,
                deviceId: item.deviceId,
              };
            });
          }
          this.vehicle_no = vehicleList;
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Get vehicle list failed', 'Error!');
        });
    },
    getDriverName() {
      this.loading = true;
      const params = {};
      if (this.gAId !== '') {
        params.region = this.gAId;
      }
      params.$limit = 0;
      let driverList = [];
      if (this.user.roleName == 'Journey Manager') {
        params.regionJourneyManager = `["${this.user._id}"]`;
      }
      // if (this.regionManagersIdList.length !== 0) {
      //   params.regionRegionManager = this.regionManagersIdList;
      // }

      this.$driverDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            this.driver_name = res.data.docs.map(item => {
              return {
                value: item._id,
                drivers: item.driverName,
              };
            });
          }
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Get driver list failed', 'Error!');
        });

      // }
    },
    getDeviceName(e) {
      if (
        this.trip.vehicleId !== null &&
        typeof this.trip.vehicleId === 'object' &&
        this.trip.vehicleId.key !== ''
      ) {
        this.inputValid2 = true;
        this.updateFormValidity();
      } else {
        this.inputValid2 = false;
        this.updateFormFalse();
      }
      const params = {};
      if (this.trip.vehicleId.deviceId) {
        params._id = this.trip.vehicleId.deviceId;
        this.loading = true;
        params.$limit = 0;
        let deviceList = [];
        this.$deviceDataRepository
          .list(params)
          .then(res => {
            this.loading = false;
            if (res.data.docs) {
              deviceList = res.data.docs.map(item => {
                return {
                  key: item._id,
                  value: item.deviceId,
                };
              });
            }
            this.trip.deviceId = deviceList[0].value;
            this.selectedDeviceId = deviceList[0].key;
          })
          .catch(error => {
            this.loading = false;
            this.$snotify.error('Get device list failed', 'Error!');
          });
      } else {
        this.loading = false;
        this.$snotify.error('Vehicle not connected to any device .', 'Error!');
      }
    },
    getRouteName() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      // params.region = this.gAId;
      let routeList = [];
      params.$select = ['name', '_id', 'startSite', 'endSite'];
      this.$triprouteDataRepository
        .list(params)
        .then(res => {
          this.loading = false;
          if (res.data.docs) {
            routeList = res.data.docs;
          }
          this.route_list = routeList;
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Get route list failed', 'Error!');
        });
    },

    /*get locations */
    getLocations() {
      this.loading = true;
      const params = {};
      params.$limit = 0;
      if (this.gAId != '') {
        params.region = this.gAId;
      }
      params.status = 'active';
      params.$select = ['siteName', 'siteType', '_id', 'regionName', 'region', 'latitude', 'longitude'];
      this.$siteDataRepository
        .list(params)
        .then(res => {
          this.locationList = res.data.docs;

        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('Get route list failed', 'Error!');
        });
    },
    addField(fieldType) {
      this[fieldType].splice(-1, 0, { locationId: null });
    },
    removeField(index, fieldType) {
      console.log('index', index);
      console.log('fieldType', fieldType);
      this[fieldType].splice(index, 1);
    },

    /*add new location */
    // addField(value, fieldType) {
    //   fieldType.push({
    //     value: ''
    //   });
    // },

    // /*remove location */
    // removeField(index, fieldType) {
    //   fieldType.splice(index, 1);
    // },

    /*handle change of stops */
    handleChange(event, index) {

      if (
        this.locations.length >= 3 &&
        this.locations[2].locationId && this.locations[2].locationId._id !== ''
      ) {
        this.inputValid6 = true;
        this.updateFormValidity();
      } else {
        this.inputValid6 = false;
        this.updateFormFalse();
      }

      this.clearIndex = index;
      const locations = this.locations;
      console.log('handleChange', this.locations);
      if (index > 0) {
        this.checkRoute(index);
      }
    },

    closeRoute() {
      this.$modal.hide('gasFlowDia');
      this.locations[this.clearIndex].locationId = '';
      this.clearRoute();
    },

    /*check if route exists between two locations or not */
    checkRoute(index) {
      //pick the selected location from index and index-1 and then find route

      const route = this.route_list.find(
        el =>
          this.locations[index - 1].locationId._id === el.startSite &&
          this.locations[index].locationId._id === el.endSite,
      );

      if (route) {
        let val = {
          routeId: route._id,
          startSite: route.startSite,
          endSite: route.endSite,
        };
        this.list.push(val);
      } else {
        this.$modal.show('gasFlowDia');

        this.routeData.startLocation = this.locations[index - 1].locationId.siteName;
        this.routeData.endLocation = this.locations[index].locationId.siteName;
        this.routeData.startLocId = this.locations[index - 1].locationId._id;
        this.routeData.endLocId = this.locations[index].locationId._id;
        this.routeData.routeMarkers[0].latitude = String(this.locations[index - 1].locationId.latitude);
        this.routeData.routeMarkers[0].longitude = String(this.locations[index - 1].locationId.longitude);
        this.routeData.routeMarkers[0].message = this.locations[index - 1].locationId.siteName;
        this.routeData.routeMarkers[1].latitude = String(this.locations[index].locationId.latitude);
        this.routeData.routeMarkers[1].longitude = String(this.locations[index].locationId.longitude);
        this.routeData.routeMarkers[1].message = this.locations[index].locationId.siteName;
      }

    },
    clearRoute() {
      this.routeData.startLocation = '';
      this.routeData.endLocation = '';
      this.routeData.time = '';
      this.routeData.distance = '';
      this.routeData.routeMarkers[0].latitude = '';
      this.routeData.routeMarkers[0].longitude = '';
      this.routeData.routeMarkers[0].message = '';
      this.routeData.routeMarkers[1].latitude = '';
      this.routeData.routeMarkers[1].longitude = '';
      this.routeData.routeMarkers[1].message = '';
    },

    /*route create */
    createRoute() {
      this.loading = true;
      this.tripRoute = {
        approxDistance: this.routeData.distance,
        approxTime: this.routeData.time,
        status: 'active',
        startSite: this.routeData.startLocId,
        endSite: this.routeData.endLocId,
        region: this.gAId,
        reportAssessment: '',
        routeMarkers: this.routeData.routeMarkers,
      };
      console.log('hii there', this.tripRoute);
      return tripRouteService
        .addtripRoute(this.tripRoute)
        .then(response => {
          // let docId = response._id;
          // this.uploadDocument(docId);

          this.loading = false;
          this.flash = false;
          this.$snotify.success('route added!', 'Success!');
          this.clearRoute();
          this.getRouteName();
          this.checkRoute(this.clearIndex);

          this.$modal.hide('gasFlowDia');
          // this.getLocations();
          // this.$router.push('/TripGroupCreate')
        })
        .catch(error => {
          this.loading = false;
          this.$snotify.error('trip Add failed! Try Again', 'Error!');
          // if (error.data.message.includes('must be one of')) {
          //   this.flash = true;
          //   this.flashType = 'error';
          //   this.flashMessage = 'New route add is failed.Please try again!';
          // }
        });
    },

    /*get list of regions */
    getRegionList() {
      this.loading = true;
      this.params.$limit = 0;
      if (this.user.roleName == 'GA Head') {
        this.params.regionManager = this.regionManagersIdList;
      }
      if (this.user.roleName === 'Journey Manager') {
        this.isGeographicalAreaDisable = true;
        this.params.journeyManager = `["${this.user._id}"]`;
      }
      let regionlist = [];
      this.$regionDataRepository
        .list(this.params)
        .then(res => {
          this.loading = false;
          this.regionListFilter = res.data.docs;
          if (res.data.docs) {
            regionlist = res.data.docs.map(item => {
              return {
                key: item._id,
                value: item.name,
              };
            });
          }
          this.region_list = regionlist;

          if (this.region_list.length === 1) {
            this.region_list ? (this.trip.region = this.region_list[0]) : (this.trip.region = '');
            this.selectGA(this.region_list[0])
          }
          // this.user.roleName === "Journey Manager" ? this.tripRoute.region = this.region_list[0].key : this.tripRoute.region = '';
        })
        .catch(error => {
          this.loading = false;
          console.error('Region.requestFunction-error:', error);
          this.$snotify.error('Get region list failed', 'Error!');
        });
    },

    fieldClassName: function (field) {
      if (!field) {
        return '';
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return 'has-success';
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return 'has-danger';
      }
    },
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
  },
};
</script>

<style scoped>
.required-field>label::after {
  content: '*';
  color: red;
  margin-left: 0.25rem;
}

.form-control-feedback {
  font-weight: 100;
  color: red;
  position: initial;
  text-align: left;
  height: auto;
  width: auto;
}

.has-danger {
  color: red;
}

.mt {
  margin-top: 7px;
}

.gradientbt {
  background-image: linear-gradient(to right,
      rgba(38, 153, 251),
      rgba(146, 205, 255));
  color: white;
}

.box-body {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
}

.svg-icons {
  margin-top: 31px;
  margin-left: 12px;
}

.d-flex {
  display: flex;
}

.table {
  padding: 20px;
}

table>tr>th {
  margin: 20px;
}

.box-header {
  background-image: linear-gradient(to right,
      rgba(38, 153, 251),
      rgba(146, 205, 255));
}

.dropdown-toggle {
  background-color: rgba(255, 132, 78);
}

.tablinks {
  background-image: linear-gradient(to right,
      rgba(38, 153, 251),
      rgba(146, 205, 255));
}

th {
  padding-left: 20px;
}

.trip-detail-tbl td,
th {
  padding: 4px 15px !important;
}

/deep/ .tripModal .v--modal-box {
  min-height: 500px !important;
  max-height: 500px !important;
  height: 500px !important;
  overflow-y: scroll !important;
}
</style>



// WEBPACK FOOTER //
// Trip-Group-Create.vue?bfd6abfa